<script setup lang="ts">
import { ChatPanelTip } from '@/constants/chat';
import {
  iKeyIcon,
  iKeyIconShape,
  iKeyIconType,
  iKeyIconStyle,
  iKeyIconSize,
} from '@inscribe/signal';

defineProps<{
  tip: ChatPanelTip;
}>();
</script>

<template>
  <div
    class="chat-panel-tip d-flex flex-row align-items-center i-gap-5 i-radius-2xl"
    data-testid="chat-panel-tip"
  >
    <i-key-icon
      icon="medium_lighting_light_bulb_on"
      :shape="iKeyIconShape.SQUARE"
      :type="iKeyIconType.NEUTRAL"
      :size="iKeyIconSize.XS"
      :icon-style="iKeyIconStyle.SOLID"
    />
    <span class="tip-text i-text-body-3">{{ tip.text }}</span>
  </div>
</template>

<style lang="scss" scoped>
.chat-panel-tip {
  border: 1px solid var(--border-neutral-subtle);
  padding: 12px 48px 12px 12px;

  .tip-icon {
    flex-shrink: 0;
  }

  .tip-label {
    color: var(--text-neutral-bold);
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .tip-text {
    color: var(--text-neutral-bold);
    flex: 1;
  }
}
</style>
